import reportsApiService from './reportsApi.service';

export interface LevelHistoryItem {
  id: number;
  fechaEvento: string | null;
  oldLevel: number | null;
  nivelNuevo: number | null;
  stageUpdated: boolean;
  source: 'CHALLENGE' | 'DIAGNOSTIC';
  diagnosticAssignmentId: string | null;
}

export default {
  getHistory(bookUserId: number | string, onlyStageUpdates = false): Promise<{ data: LevelHistoryItem[] }> {
    return reportsApiService.get('/user-advance-level/history', {
      bookUserId,
      onlyStageUpdates,
    });
  },
};
